import { render, staticRenderFns } from "./UsageNationalVoice.vue?vue&type=template&id=87ae9232&scoped=true&"
import script from "./UsageNationalVoice.vue?vue&type=script&lang=js&"
export * from "./UsageNationalVoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ae9232",
  null
  
)

export default component.exports